import { useEffect, useRef, useState } from 'react';
import {
    Button,
    Card,
    Col,
    Container,
    Form,
    Image,
    ListGroup,
    Row,
    Spinner,
    Stack,
} from 'react-bootstrap';
import './bulkUpload.scss';
import {
    useUplooadImagesMutation,
    useValidateImagesMutation,
} from './bulkUploadApi';
import LoadingComponent from '../LoadingComponent';
import { useTranslation } from 'react-i18next';

const BulkUpload = () => {
    const { t } = useTranslation();
    const [loading, setLoading] = useState(false);
    const [buttonLoading, setButtonLoading] = useState(false);
    const [files, setFiles] = useState([]);
    const [completedFiles, setCompletedFiles] = useState([]);

    const [validateImages] = useValidateImagesMutation();
    const [uploadImages] = useUplooadImagesMutation();

    const filesizes = (bytes, decimals = 2) => {
        if (bytes === 0) return '0 Bytes';
        const k = 1024;
        const dm = decimals < 0 ? 0 : decimals;
        const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
        const i = Math.floor(Math.log(bytes) / Math.log(k));
        console.log(
            parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i],
            'dsdsd[i]'
        );

        return (
            parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i]
        );
    };
const handleFileChange = async (e) => {
    setLoading(true);

    const files = e.target.files;
    const newImages = [];

    Array.from(files).forEach((file) => {
        const fileName = file.name.toLowerCase();

        // Allow only JPG and JPEG
        const isJpgOrJpeg =
            file.type === 'image/jpeg' ||
            fileName.endsWith('.jpg') ||
            fileName.endsWith('.jpeg');

        if (isJpgOrJpeg) {
            newImages.push({
                file: file,
                imagefilename: file.name,
                fileSize: filesizes(file.size),
                fileImage: file ? URL.createObjectURL(file) : null,
            });
        } else {
            alert('Only JPG and JPEG image formats are allowed.');
        }
    });

    if (newImages.length === 0) {
        setLoading(false);
        return;
    }

    try {
        let { data } = await validateImages(
            newImages.map(({ imagefilename }) => ({ imagefilename }))
        );

        let merged = data.map((meta) => {
            const match = newImages.find(
                (img) => img.imagefilename === meta.imageFileName
            );

            return {
                ...meta,
                fileImage: match ? match.fileImage : null,
                fileSize: match ? match.fileSize : null,
                file: match ? match.file : null,
            };
        });

        setFiles((prev) => {
            return [...prev, ...merged];
        });

        setLoading(false);
    } catch (error) {
        setLoading(false);
    }
};

    const fileInputRef = useRef();
    const triggerFileInput = () => {
        fileInputRef.current.click();
    };

    const deleteImage = (indexToRemove) => {
        const updatedArray = files.filter(
            (_, index) => index !== indexToRemove
        );
        setFiles([...updatedArray]);
    };

    const handleUpload = async () => {
        setButtonLoading(true);
        const validItems = files.filter((item) => item.isValidFileName);
        const results = [];
        for (const item of validItems) {
            try {
                const formData = new FormData();
                formData.append('EyeTestImage', item.file);
                formData.append('EyeTestId', item.eyeTestId);

                const { data } = await uploadImages(formData);

                console.log(`✅ Uploaded: ${item.imageFileName}`, data);

                // Append to results array
                results.push(item);
            } catch (error) {
                console.error(`❌ Failed: ${item.imageFileName}`, error);
            }
        }

        const filtered = files.filter((item1) =>
            results.some(
                (item2) => item2.isValidFileName !== item1.isValidFileName
            )
        );

        setFiles([...filtered]);
        setCompletedFiles((prev) => [...prev, ...results]);
        console.log('🚀 All Uploads Done:', results);

        setButtonLoading(false);
    };

    useEffect(() => {
        console.log(completedFiles, 'completedFilescompletedFiles');
    }, [completedFiles]);

    return (
        <Container>
            {loading ? <LoadingComponent /> : ''}
            <Row>
                <Col md={2}></Col>
                <Col md={8}>
                    <Card>
                        <Card.Body>
                            <Card.Title>
                                Télécharger plusieurs images de rétines
                            </Card.Title>
                            <Card.Text>
                                Seuls les fichiers (jpeg, jpg) d'une taille
                                inférieure à 10 Mo sont acceptés. Les noms de
                                fichiers doivent correspondre au code du test
                                correspondant.
                            </Card.Text>
                            <div className="custom-upload">
                                <input
                                    type="file"
                                    ref={fileInputRef}
                                    multiple
                                    accept=".jpg,.jpeg,image/jpeg"
                                    onChange={handleFileChange}
                                />
                                <Button onClick={triggerFileInput}>
                                    Drag and drop or Choose your retinal scan
                                    images
                                </Button>
                            </div>
                            {files.length > 0 && (
                                <div className="peview_uploaded_images">
                                    {files.map((file, index) => (
                                        <Stack
                                            key={index}
                                            className="peview_uploaded_images_inner"
                                            direction="horizontal"
                                            gap={3}
                                        >
                                            <Image
                                                src={file.fileImage}
                                                rounded
                                            />
                                            <Stack gap={1}>
                                                <h3>
                                                    {file.imageFileName}{' '}
                                                    <span>
                                                        ({file.fileSize})
                                                    </span>
                                                </h3>
                                                <Stack
                                                    className=""
                                                    direction="horizontal"
                                                    gap={3}
                                                >
                                                    <Button
                                                        variant="link"
                                                        onClick={() =>
                                                            deleteImage(index)
                                                        }
                                                    >
                                                        Supprimer
                                                    </Button>
                                                    <div
                                                        style={{
                                                            color: !file.isValidFileName
                                                                ? 'rgba(255, 0, 0, 1) '
                                                                : 'rgba(0, 128, 0, 1)',
                                                        }}
                                                    >
                                                        {!file.isValidFileName
                                                            ? '✕  Fichier non valide ou ne correspondant à aucun tests'
                                                            : '✓  Image valide'}
                                                    </div>
                                                </Stack>
                                            </Stack>
                                        </Stack>
                                    ))}
                                </div>
                            )}
                            <Button
                                className="mt-5 mb-3"
                                variant="primary"
                                disabled={buttonLoading}
                                onClick={handleUpload}
                            >
                                {buttonLoading && (
                                    <Spinner
                                        animation="border"
                                        role="status"
                                        size="sm"
                                    >
                                        <span className="visually-hidden">
                                            Loading...
                                        </span>
                                    </Spinner>
                                )}{' '}
                                {t('Télécharger')}
                            </Button>

                            {completedFiles.length > 0 && (
                                <>
                                    <hr />
                                    <div className="peview_uploaded_images mt-2">
                                        {completedFiles.map((file, index) => (
                                            <Stack
                                                key={index}
                                                className="peview_uploaded_images_inner"
                                                direction="horizontal"
                                                gap={3}
                                            >
                                                <Image
                                                    src={file.fileImage}
                                                    rounded
                                                />
                                                <Stack gap={1}>
                                                    <h3>
                                                        {file.imageFileName}{' '}
                                                        <span>
                                                            ({file.fileSize})
                                                        </span>
                                                    </h3>
                                                    <Stack
                                                        className=""
                                                        direction="horizontal"
                                                        gap={3}
                                                    >
                                                        {/* <Button variant="link" onClick={() => deleteImage(index)}>Supprimer</Button> */}
                                                        <div
                                                            style={{
                                                                color: !file.isValidFileName
                                                                    ? 'rgba(255, 0, 0, 1) '
                                                                    : 'rgba(0, 128, 0, 1)',
                                                            }}
                                                        >
                                                            {!file.isValidFileName
                                                                ? '✕  Fichier non valide ou ne correspondant à aucun tests'
                                                                : '✓  Image valide'}
                                                        </div>
                                                    </Stack>
                                                </Stack>
                                            </Stack>
                                        ))}
                                    </div>
                                </>
                            )}
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </Container>
    );
};
export default BulkUpload;
